import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/providers/ThemeProvider";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-9 w-9 relative border-2 border-[var(--color-header-accent,#0A74FF)] hover:border-[var(--color-header-accent,#0A74FF)] focus:border-[var(--color-header-accent,#0A74FF)]"
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
    >
      <Sun className="h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0 text-[var(--color-text,#e5e5e5)]" />
      <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 text-[var(--color-text,#e5e5e5)]" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}